import {
  AlertIcon,
  Box,
  Modal,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@agrotoken-tech/ui';
import { usePendingChangesAlert } from '@bcba/frontend-utils';
import { useTranslation } from '@bcba/react-hooks';
import { ReactNode, useState } from 'react';
import { DigitalDossierHeader } from './DigitalDossierHeader';

export interface TabData {
  title: string;
  icon?: ReactNode;
  content: ReactNode;
}

interface Props {
  title: string;
  tabsData: TabData[];
  badge?: ReactNode;
  theme?: any;
  hasUserPendingChanges: boolean;
  setUserHasPendingChanges: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DigitalDossierLayout = ({
  title,
  tabsData,
  badge,
  theme = undefined,
  hasUserPendingChanges,
  setUserHasPendingChanges,
}: Props) => {
  const { t } = useTranslation();
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  const [tabIndex, setTabIndex] = useState<number>(0);
  const {
    isPendingChangeAlertOpen,
    confirmPendingChangeAlertModal,
    cancelPendingChangeAlertModal,
    onPendingChangeAlertOpen,
  } = usePendingChangesAlert(hasUserPendingChanges, setUserHasPendingChanges);

  const handleTabsChange = (index: number) => {
    setCurrentTabIndex(index);
    if (hasUserPendingChanges) {
      onPendingChangeAlertOpen();
    } else {
      setTabIndex(index);
    }
  };

  const handleConfirmPendingChangeAlertModal = () => {
    confirmPendingChangeAlertModal();
    setTabIndex(currentTabIndex);
  };

  return (
    <>
      <Stack gap={8}>
        <DigitalDossierHeader title={title} badge={badge} />
        <Tabs isLazy index={tabIndex} onChange={handleTabsChange}>
          <Box overflow={'auto'}>
            <TabList gap={8}>
              {tabsData.map(({ title, icon }) => (
                <Tab
                  minWidth={'fit-content'}
                  px={0}
                  key={title}
                  gap={2}
                  display={'flex'}
                  alignItems={'center'}
                >
                  {title} {icon ?? null}
                </Tab>
              ))}
            </TabList>
          </Box>
          <TabPanels py={6}>
            {tabsData.map(({ content, title }) => {
              return (
                <TabPanel px={0} key={title}>
                  {content}
                </TabPanel>
              );
            })}
          </TabPanels>
        </Tabs>
      </Stack>
      <Modal
        isOpen={isPendingChangeAlertOpen}
        onClose={cancelPendingChangeAlertModal}
        title={t('explorer.signUp.modal.exitForm.title')}
        text={t('explorer.signUp.modal.exitForm.text')}
        onClickConfirm={handleConfirmPendingChangeAlertModal}
        labelBtnConfirm={t('common.confirm')}
        variantBtnConfirm="primary"
        labelBtnClose={t('common.cancel')}
        icon={AlertIcon}
        iconVariant="warning"
      />
    </>
  );
};
